import type { ListParams } from '@/shared/types';

export const countryKeys = {
  all: ['countries'] as const,
  list: (params: ListParams) => ['countries', 'list', params] as const,
  detail: (id: string | number) => ['countries', 'detail', id] as const,
};
